<template>
  <div class="candidate-contact fill-height">
    <CandidateRejectNotificationForm
      v-if="notificationType === notificationTypes.CANDIDATE_DECLINED"
      :key="key"
      :email-text="emailText"
      :candidate="candidate"
    />
    <CandidateContactChatForm
      v-else
      :key="key"
      :email-text="emailText"
      :sms-text="smsText"
      :candidate="candidate"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CandidateContactChatForm from '../../forms/CandidateContactChatForm.vue';
import CandidateRejectNotificationForm from '../../forms/CandidateRejectNotificationForm.vue';
import User from '../../orm/models/User/User';
import NotificationTemplate from '../../orm/models/Company/NotificationTemplate/NotificationTemplate';
import { compileNotificationTemplate } from '../../functions';
import { notificationChannelType, notificationType } from '../../enums';

export default {
  name: 'CandidateContact',
  components: {
    CandidateRejectNotificationForm,
    CandidateContactChatForm,
  },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      user: User.getAuthUser(),
      notificationTypes: notificationType,
      key: Date.now(),
    };
  },
  computed: {
    ...mapGetters('candidatePage', ['notificationType']),
    emailText() {
      return this.compileNotificationTemplate(this.notificationType, notificationChannelType.EMAIL);
    },
    smsText() {
      return this.compileNotificationTemplate(this.notificationType, notificationChannelType.SMS);
    },
  },
  watch: {
    notificationType() {
      this.key = Date.now();
    },
  },
  beforeDestroy() {
    this.$store.commit('candidatePage/setNotificationType', notificationType.CANDIDATE_COMMON);
  },
  methods: {
    compileNotificationTemplate(type, channel) {
      const template = NotificationTemplate.query()
        .where('companyId', this.user.company.id)
        .where('type', type)
        .where('channel', channel)
        .first();

      return compileNotificationTemplate(
        template?.template ? template.template : '',
        this.user,
        this.user.company,
        this.candidate.vacancy,
        this.candidate,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.candidate-contact {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}
</style>

<i18n locale="en" lang="yaml">
  messageSent: Message sent
</i18n>

<i18n locale="ru" lang="yaml">
  messageSent: Сообщение отправлено
</i18n>
